/**
 * Authentication utilities for the application
 */

/**
 * Get the authentication header for API requests
 * @returns {Object} Authentication header object with cache control
 */
export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token 
    ? { 
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      } 
    : {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      };
};

/**
 * Check if the user is authenticated
 * @returns {boolean} True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

/**
 * Set authentication token in local storage
 * @param {string} token JWT token
 */
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
};

/**
 * Logout the user by removing the token
 */
export const logout = () => {
  localStorage.removeItem('token');
}; 